// import { FeatureCollection } from "geojson";

const dataset = async function(downloadPath: string) {
  const configPath = downloadPath
  const resp = await fetch(configPath);
  return await resp.json();
}

export default dataset